<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h560_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="合同号"
                  prop="contractId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.contractId"
                    filterable
                    clearable
                    placeholder="请选择合同号"
                    style="width:100%"
                    :disabled="eventType==='view'"
                    @change="changeContractFun"
                  >
                    <el-option
                      v-for="item in contractOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span style="float: right; padding-left: 10px; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.contractCode"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item label="合同名称">
                  <el-input
                    v-model="dialogAddEditViewForm.contractName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="类型"
                  prop="type"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.type"
                    filterable
                    placeholder="请选择类型"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.typeValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="单位"
                  prop="unit"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.unit"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="规格型号"
                  prop="specification"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.specification"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="单价"
                  prop="price"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.price"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'price')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'price', 2);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="税率"
                  prop="taxRateValue"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.taxRateValue"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'taxRateValue')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'taxRateValue', 2);"
                  >
                    <template slot="append">
                      %
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="含税价格"
                  prop="taxInclusivePrice"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.taxInclusivePrice"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'taxInclusivePrice')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'taxInclusivePrice', 2);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="需要定样"
                  required
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.needSample"
                    :disabled="eventType==='view'"
                  >
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="2">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="绩效考核"
                  required
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.performanceAssess"
                    :disabled="eventType==='view'"
                  >
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="2">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="是否出入库管理"
                  required
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.isInOutDepot"
                    :disabled="eventType==='view'"
                  >
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="0">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注说明信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    :autosize="{minRows: 3}"
                    :disabled="eventType==='view'"
                    style="margin-bottom: 3px;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// API
import { listContractApi } from '@/api/v2/contract'
import { viewContractServiceItemApi, saveContractServiceItemApi } from '@/api/v2/contractServiceItem'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        specification: [{ required: false, message: '请输入规格型号', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        taxRateValue: [{ required: true, message: '请输入税率', trigger: 'blur' }],
        taxInclusivePrice: [{ required: true, message: '请输入含税价格', trigger: 'blur' }],
        contractId: [{ required: true, message: '请选择合同号', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        remark: [{ max: 256, message: '最多输入256个字符', trigger: 'blur' }]
      },
      contractOptions: [],
      typeOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.typeOptions = []
        _this.dialogAddEditViewForm = {
          contractId: '',
          contractCode: '',
          contractName: '',
          sort: '',
          type: '',
          typeValue: '',
          name: '',
          unit: '',
          specification: '',
          price: '',
          taxRate: '',
          taxRateValue: '',
          taxInclusivePrice: '',
          performanceAssess: 2,
          needSample: 2,
          isInOutDepot: 0,
          remark: ''
        }
        if (_this.eventType !== 'view')
          _this.loadContractData()
        if (_this.eventType !== 'add') {
          _this.loadContractServiceItemData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadContractServiceItemData () {
      let _this = this;
      viewContractServiceItemApi({ id: _this.dataId }).then(response => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id
        _this.dialogAddEditViewForm.taxRateValue = Number((Number(data.taxRate) * 100).toFixed(2))
        _this.initTypeDataFun(_this.dialogAddEditViewForm.sort)
      })
    },
    // 初始合同下拉数据
    loadContractData () {
      let _this = this;
      _this.contractOptions = []
      listContractApi().then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.contractOptions.push({ label: item.code, data: item.id, name: item.name, code: item.code, sort: item.sort, provinceName: item.provinceName, provinceId: item.provinceId, year: item.year })
        })
      })
    },
    // 选择合同回调
    changeContractFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.contractOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.contractCode = selectItem ? selectItem.label : ''
      _this.dialogAddEditViewForm.contractName = selectItem ? selectItem.name : ''
      _this.dialogAddEditViewForm.sort = selectItem ? selectItem.sort : '';
      _this.dialogAddEditViewForm.type = ''
      _this.initTypeDataFun(_this.dialogAddEditViewForm.sort)
    },
    // 选择合同加载类型
    initTypeDataFun (sort) {
      let _this = this;
      _this.typeOptions = []
      if (Number(sort) === 1) {
        _this.typeOptions.push({ label: '终端运维', data: 1 })
      } else if (Number(sort) === 2) {
        _this.typeOptions.push({ label: '人员服务', data: 2 })
        _this.typeOptions.push({ label: '物资服务', data: 3 })
        _this.typeOptions.push({ label: '物料制作', data: 4 })
        _this.typeOptions.push({ label: '色彩终端', data: 5 })
        _this.typeOptions.push({ label: '品系宣介', data: 6 })
        _this.typeOptions.push({ label: '其他费用', data: 7 })
      } else if (Number(sort) === 3) {
        //_this.typeOptions.push({ label: '终端运维', data: 1 })
        //_this.typeOptions.push({ label: '人员服务', data: 2 })
        //_this.typeOptions.push({ label: '物资服务', data: 3 })
        //_this.typeOptions.push({ label: '物料制作', data: 4 })
        //_this.typeOptions.push({ label: '色彩终端', data: 5 })
        //_this.typeOptions.push({ label: '品系宣介', data: 6 })
        //_this.typeOptions.push({ label: '其他费用', data: 7 })
        _this.typeOptions.push({ label: '人员服务', data: 2 })
        _this.typeOptions.push({ label: '宣传展示（服务类）', data: 3 })
        _this.typeOptions.push({ label: '宣传展示（制作类）', data: 4 })
        _this.typeOptions.push({ label: '场地租赁', data: 8 })
      }
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '合同服务项目信息', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            _this.dialogAddEditViewForm.taxRate = Number((Number(this.dialogAddEditViewForm.taxRateValue) / 100).toFixed(4))
            saveContractServiceItemApi(_this.dialogAddEditViewForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {

    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
